import { Model } from 'modules/core/lib/mobx-rest'

interface IBookkeeper {
  id?: number
  access_id: number
  company_id?: number
  cycle_id?: number
}

class Bookkeeper extends Model<IBookkeeper> {
  static urlRoot() {
    return '/bookkeepers_management/bookkeepers'
  }
}

export default Bookkeeper
